import { Component, ViewChild } from '@angular/core'
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent } from '../../shared'
import { SafetyFeedbackDashboardComponent } from './safety-feedback-dashboard.component'
import { SafetyFeedbacksComponent } from './safety-feedbacks.component'

@Component({
    templateUrl: './safety-feedback-page.component.html',
    standalone: true,
    imports: [
        NgbNav,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        SafetyFeedbackDashboardComponent,
        SafetyFeedbacksComponent,
    ],
})
export class SafetyFeedbackPageComponent extends BaseComponent {
    @ViewChild(SafetyFeedbackDashboardComponent)
    dashboard?: SafetyFeedbackDashboardComponent

    activeTab = 0

    constructor() {
        super()
        this.initialLoadingComplete()
    }

    tabChanged() {
        if (this.isDashboardTab) {
            this.dashboard?.refresh()
        }
    }

    get isDashboardTab() {
        return Number(this.activeTab) === 0
    }

    get isRecordsTab() {
        return Number(this.activeTab) === 1
    }
}
